import React from 'react';

import './SellFundReviewRow.scss';

import If from '../../../Shared/If/If';
import CostBasisSnapshot from '../../../Sell/CostBasisSnapshot/CostBasisSnapshot';
import {
  DELIVERY_MAIL_CHECK_TO_SCHOOL,
  NON_RETIREMENT,
  PRODUCT_TYPE_LABEL_MAP,
} from '../../../../settings/settings';
import {
  replaceSpecialCharacterWith,
  replaceSpecialCharacterWithSpace,
} from '../../../../utils/shoppingCart/shopping-cart-utility';
import {
  isCollegeDistribute,
  isAutomaticSell,
  isSell,
} from '../../../../utils/transactions-util';
import words from '../../../../utils/words';
import { formatUnixDate } from '../../../../utils/dates/date-utility';
import ToolTip from '../../../Shared/ToolTip/ToolTip';
import { useSelector } from 'react-redux';
import { getReddemTradeDates } from 'src/redux/modules/executeRedemption/executeRedemption.selectors';

const SellFundReviewRow = ({ fund, deliveryMethod }) => {
  const reddemTradeDates = useSelector(getReddemTradeDates);
  const {
    agreementType = '',
    agreementNumber = '',
    displayClassification = '',
    formattedEntityNames = '',
    fundName = '',
    payee = '',
    productType = '',
    ticker = '',
  } = fund;

  const formattedDisplayClassification = replaceSpecialCharacterWith(
    displayClassification,
    '-'
  ).toUpperCase();
  const formattedAgreementType =
    replaceSpecialCharacterWithSpace(agreementType).toUpperCase();
  return (
    <div
      className={
        isAutomaticSell() ? 'auto-sell-fund-review-row' : 'sell-fund-review-row'
      }
    >
      <If test={isCollegeDistribute()}>
        <div className="sell-fund-review-row-classification">
          {PRODUCT_TYPE_LABEL_MAP[productType]}
        </div>
      </If>
      <If test={!isCollegeDistribute()}>
        <div className="sell-fund-review-row-classification">
          {formattedDisplayClassification} / {formattedAgreementType}
        </div>
      </If>
      <div className="sell-fund-review-row-space">
        <span className="sell-fund-review-row-fund-name"> {fundName} </span>
        <span className="sell-fund-review-row-ticker">{ticker}</span>
      </div>
      <div className="sell-fund-review-row-space">
        <span className="blocked_data sell-fund-review-row-agreement-number">
          {agreementNumber} • {formattedEntityNames}
        </span>
        {isSell() && (
          <div>
            Projected Trade Date:
            <strong className="sell-projected-date-take-home-amount">
              {formatUnixDate(reddemTradeDates[fund.agreementID])}
            </strong>
            <span>
              <ToolTip
                message={
                  'For most funds, trades received after the close of regular trading on the New York Stock Exchange (usually 4 p.m. ET) will be priced at the next business day’s close.  For Government Money Fund and U.S. Treasury Money Fund, trades in and out of these funds and exchanges solely between these funds received after the fund’s close (normally 5 p.m. ET) will be priced at the next business day’s close.'
                }
              />
            </span>
          </div>
        )}
      </div>
      <If
        test={
          isCollegeDistribute() &&
          deliveryMethod !== DELIVERY_MAIL_CHECK_TO_SCHOOL
        }
      >
        <div className="sell-fund-review-row-space">
          <span className="sell-fund-review-row-agreement-number">
            {' '}
            Payee: {payee}{' '}
          </span>
        </div>
      </If>
      <If
        test={
          isCollegeDistribute() &&
          deliveryMethod === DELIVERY_MAIL_CHECK_TO_SCHOOL
        }
      >
        <div className="sell-fund-review-row-space">
          <span className="sell-fund-review-row-agreement-number">
            {' '}
            Taxable Party: Beneficiary{' '}
          </span>
        </div>
      </If>
      <If test={displayClassification === NON_RETIREMENT}>
        <CostBasisSnapshot fund={fund} labelComponent="Cost Basis:" />
      </If>
      <If test={fund.moneyMarketReformMessage}>
        <div
          className="sell-fund-review-row-mmr-event-message"
          dangerouslySetInnerHTML={{ __html: fund.moneyMarketReformMessage }}
        />
      </If>
      <If test={fund.closeout && !fund.sweep}>
        <div className="sell-fund-review-row-close-out-note">
          <span> NOTE: </span> Submitting this transaction will close this{' '}
          {words.fund}.{' '}
        </div>
      </If>
      <If test={fund.wireFee && !isCollegeDistribute()}>
        <div className="sell-fund-review-row-close-out-note">
          <span> NOTE: </span> Additional $5 wire fee will be charged in a
          separate transaction.{' '}
        </div>
      </If>
    </div>
  );
};

export default SellFundReviewRow;
